<template>
  <transition name="el-fade-in-linear">
    <div class="index">
      <router-link to>
        <img
          @click="$router.back(-1)"
          class="backPic"
          src="../../static/images/back.png"
        />
      </router-link>
      <div class="detailTitle">地铁线路拓展至10条 北斗院算法服务升级</div>
      <div class="detailTitleSecond">深圳北斗应用技术研究院 8月18日</div>
      <div class="line"></div>
      <div class="detailPic">
        <img
          class="newsDetailSize"
          src="../../static/images/newsDetailPic3.png"
        />
        <img
          class="newsDetailSize secondTextPic"
          src="../../static/images/newsDetailPic4.png"
        />
      </div>
      <div class="detailTitleText">
        随着8月18日深圳地铁6、10号线的正式开通，深圳地铁线路已拓展到10条，运营里程达383公里。为助力新线开通，北斗院对深圳地铁清分算法和TOS系统进行了优化升级工作，优化后的清分算法计算效率提高20倍，TOS系统对全网客流拥挤度实现实时计算，保障了运营主体收益的同时也提升了乘客出行舒适度。
      </div>

      <div class="detailTitleLittle">
        票务清分傻傻分不清 北斗院助力清分算法升级
      </div>
      <div class="detailTitleText">
        为提高乘客在地铁网络中出行的便捷性，增加客流高峰时段车站、设施的通行能力，深圳地铁采用全网通“一票无障碍换乘”运营模式。
        一票通简化了乘客的换乘出行过程，减少了乘客的出行乘车时间，但无法了解乘客在跨线乘车中的乘车路径和换乘站点，容易导致运营商在收益清分中产生分歧。
      </div>
      <div class="detailTitleText">
        为确保深圳地铁清分比例计算的科学与高效，北斗院对深圳地铁清分算法进行迭代升级。北斗院首次对清分算法的升级是在2016年12月地铁7、9号线新线开通之时，升级以后的清分算法满足了16年新线开通后的计算需求。
      </div>

      <div class="detailTitleText">
        2020年，为保障6、10号线的开通，北斗院对因增加线路后下降的清分计算效率问题，进行了清分算法子系统的第二次优化升级。此次清分算法程序采用多线程计算方式进行优化，加快程序运行速度，解决了原有算法不支持重叠区间进行清分的逻辑问题以及个别站点的虚拟换乘和出站换乘问题。
      </div>
      <div class="detailTitleText">
        升级后的清分算法，使清分比例的计算效率提高了20倍，清分比例结果计算时间从预计的40天缩短到现在的2天，满足了深圳10条线的清分需求，提高票务清分的准确性和合理性，保障各运营主体收益，助力地铁运营企业数字化建设。
      </div>
      <div class="detailTitleText">
        北斗院深耕清分算法的研究，除了深圳地铁的清分算法升级，还掌握了清分算法业务机制，自主研究出“基于OD反推的动态清分算法”、“基于人脸识别的清分算法”等高可靠算法。
      </div>

      <div class="detailTitleLittle">
        地铁高峰挤挤挤《地铁早班车》指引便捷出行
      </div>
      <div class="detailTitleText">
        地铁线路越来越多，如何换乘最方便、即将要乘坐的地铁是否会拥挤成了很多出行者进地铁站首要关心的问题。而帮助乘客及时掌握线网及站点客流拥挤情况，引导乘客提前规划出行路线，最大限度降低人群拥挤风险是深圳城市轨道交通信息化及智能化水平进一步体现。
        在乘客出行时，通过《地铁早班车》节目可以了解到地铁线网及站点客流拥挤情况，从而选择最舒适的出行线路。而深圳地铁TOS系统是《地铁早班车》节目客流数据播报、分析的重要支撑系统。
      </div>
      <div class="detailTitleText">
        为助力新线开通，北斗院在原有TOS系统基础上进一步优化客流预测算法、升级客流系统软件，实现对全网客流拥挤度的实时计算，为线网运营管理者提供线网实时运营指标、动态掌握线网运行情况、监控地铁运营状态。
      </div>
      <div class="detailTitleText">
        TOS系统为《地铁早班车》节目的拥挤度播报提供数据依据，向乘客提供准确的客流资讯信息与出行诱导服务，北斗院承建的TOS系统自2016年10月首次上线以来，已经进行了3次升级，为乘客提供了有效信息服务，提升出行的舒适度及便捷度。
      </div>
      <div class="detailTitleLittle">未来可期 北斗院在大交通领域继续前进</div>
      <div class="detailTitleText">
        在深圳地铁6、10号线开通的当天，深圳轨道交通四期调整工程的首批4条线路同步开工。四期调整工程力争在2025年陆续建成通车，届时，深圳将形成16条线路、总长约647公里的轨道交通网络。
        北斗院将继续利用大数据与人工智能等技术，为深圳轨道交通提供更深层更优化的技术服务，助力深圳城市轨道交通智能化建设。
      </div>

      <div class="newsDetailFoot">
        <Foot />
      </div>
    </div>
  </transition>
</template>

<script>
import Foot from "./Foot";

export default {
  name: "Index",
  data() {
    return {};
  },
  mounted: function () {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    });
  },
  components: {
    Foot,
  },
  methods: {},
};
</script>
<style scoped>
@import "./NewsDetail.css";
</style>



// WEBPACK FOOTER //
// src/views/NewsDetail1.vue